import { defineStore } from 'pinia'
import { AccountInfo } from "@azure/msal-browser";
import axios, { AxiosRequestConfig } from 'axios';

import { EnvService } from '@/services/env';

const useSessionStore = defineStore('SessionStore', {
    state : () => {
      return {
        app_name : '',
        app_title : '',
        backend_path : '',
        environment : '',

        accessToken : '',
        //accessTokenClaims : {},
        account : {} as AccountInfo | undefined,
        displayName : '',
        uvid : '',
        selected_username : '',
        usernames  : [] as string[], // used when multiple accounts are detected

        session_issues : false,
        error_messages : [] as string[]
      }
    },
    getters : {
        DisplayName : (state) => state.account?.name,
        invalidAccessToken(state){
            if (state.accessToken === '') return true
            try {
                const claims = JSON.parse(atob(state.accessToken.split('.')[1]))
                return claims.exp <= Date.now()/1000
            } catch (err) {
                console.log("Error Validating Token/Claims: ", err)
            }
            return true
        },
        isAdmin(state){
            const roles = state.account?.idTokenClaims?.roles ?? []
            return roles.includes((new EnvService()).getAttribute('VUE_APP_ADMIN_ROLE'))
        },
        roles(state){
            return state.account?.idTokenClaims?.roles ?? [];
        },
        auth_header(state){
            return {
                headers: {
                   Authorization : `Bearer ${state.accessToken}`
                } 
             }
             
        }
    },
    actions : {
        async updateUserAccount(account : AccountInfo | undefined){
          this.account = account;
        },
        async updateDisplayName(displayName : string){
          this.displayName = displayName;
        },
        async updateUserName(username : string){
          this.uvid = username;
          this.selected_username = username;
        },
        async updateAccountUserNames(usernames : string[]){
          this.usernames = usernames;
        },
        updateAccessToken(accessToken : string){
          this.accessToken = accessToken;
        },
        addErrorMessage(message : string){
          if(!this.error_messages.includes(message)) {
            this.error_messages.push(message)
          }
        },

        async request_data(method : string, path : string, func_name : string, data : {} | undefined){
          //const responseType : ResponseType = 
          const config : AxiosRequestConfig = {
            method : method,
            data : data,
            headers : { 
              Authorization : `Bearer ${this.accessToken}`,
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            responseType : 'json'
          }
          return await axios(`${this.backend_path}${path}`, config)
            .then(response => {
              if(response.data.status == 'error'){
                if(response.data.statusMessage && response.data.statusMessage.length > 0){
                  throw new Error(response.data.statusMessage)
                } else {
                  throw new Error('Unhandled Error')
                }
              }
              return response.data;
            })
            .then(data => {
              return {...data.data}
            })
            .catch((e) => {
              let message = ""
              
              if(typeof e === 'string'){
                this.addErrorMessage(`${func_name} : ${e.substring(0, 200)}`)
                return []
              }

              if(typeof e === 'object' && 'message' in e && !('data' in e.response)){
                this.addErrorMessage(`${func_name} : ${e.message.substring(0, 200)}`)
                return []
              }
              
              const response = e.response.data
              if (typeof response === 'string'){
                message = response
              }
              
              if(typeof response === 'object' && response !== null){
                if('detail' in response){
                  message = response.detail
                } else if('message' in response){
                  message = response.message
                } else if ('metadata' in response && 'statusMessage' in response.metadata) {
                  message = response.metadata.statusMessage
                } else {
                  message = "Unknown error"
                }
              }
              this.addErrorMessage(`${func_name} : ${message.substring(0, 200)}`)
              return [] // always need to return something
            })
        }

    },
    
  })
  
  export { useSessionStore }
